// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","mainContent":"App_mainContent__qBoGT","pageContent":"App_pageContent__OVA1A"};